import { gql } from "@apollo/client";

export const CREATE_RECORD_GROUP = gql`
  mutation CreateRecordGroup($group_type: RecordGroupType!, $owner_agent_id: Int!, $group_name: String!) {
    createRecordGroup(group_type: $group_type, owner_agent_id: $owner_agent_id, group_name: $group_name) {
      success
      message
      error
      data {
        group_id
        group_name
      }
    }
  }
`;

export const DELETE_RECORD_GROUP = gql`
  mutation DeleteRecordGroup($group_type: RecordGroupType!, $owner_agent_id: Int!, $group_id: Int!) {
    deleteRecordGroup(group_type: $group_type, owner_agent_id: $owner_agent_id, group_id: $group_id) {
      success
      message
      error
    }
  }
`;

export const SET_RECORD_GROUP_MEMBERSHIP = gql`
  mutation SetRecordGroupMembership(
    $group_type: RecordGroupType!
    $owner_agent_id: Int!
    $group_id: Int!
    $member_id: Int!
    $is_member: Boolean!
  ) {
    setRecordGroupMembership(
      group_type: $group_type
      owner_agent_id: $owner_agent_id
      group_id: $group_id
      member_id: $member_id
      is_member: $is_member
    ) {
      success
      message
      error
    }
  }
`;
